<template>
	<section id="id-app-catalog-categories" class="app-catalog-categories">
		<h2 class="app-catalog-categories__title">{{ $t('catalog') }}</h2>
		<div class="app-catalog-categories-tabs">
			<ul class="app-catalog-tabs__list">
				<li v-if="isNewCourses">
					<button
						@click="showNewCourses($event)"
						class="app-catalog-tabs__btn app-catalog-tabs__btn--new is-active"
						type="button"
					>{{ $t('new_courses') }}</button>
				</li>
				<li v-for="(category, index) in categories" :key="'category-' + category.id">
					<button
						@click="showCategoriesCourses(category.id, $event)"
						class="app-catalog-tabs__btn"
						:class="{ 'is-active': !isNewCourses && index === 0 }"
						type="button"
					>{{ category.title }}</button>
				</li>
			</ul>
		</div>
		<div v-if="courses.length" class="app-catalog-categories__courses">
			<p class="app-catalog-categories__courses-count">Найдено {{ courses.length }}</p>
			<ul
				class="app-catalog-categories__courses-list"
				:itemsToShow="1"
				:itemsToScroll="1"
				snapAlign="start"
			>
				<li v-for="(course, index) in items" :key="'catalog-course-' + course.id + '-' + index" class="app-catalog-categories__courses-item">
					<AppCatalogCourse
						:course="course"
						:full_only="false"
						:finished="course.finished"
						:started="course.active"
						:bookmark="course.wished"
					/>
				</li>
			</ul>

			<div v-if="courses.length > itemsPerPage" class="app-catalog-categories__bottom">
				<Paginate
					:page-count="pagesCount"
					:click-handler="changePage"
					:container-class="'app-catalog-pagination'"
				>
				</Paginate>
			</div>
		</div>
		<div v-else class="app-catalog-categories__message-holder">
			<p class="app-catalog-categories__message">
				{{ $t('messages.no_filters_message') }}
			</p>
		</div>
	</section>
</template>

<script>
import Paginate from "vuejs-paginate-next";
import AppCatalogCourse from './Catalog/AppCatalogCourse.vue';

export default {
	name: "AppCatalogCategories",

	components: {
		Paginate,
		AppCatalogCourse
	},

	props: {
		categories: Array,
		current_company_url: '',
		newest_courses: Object
	},

	data() {
		return {
			courses: [],
			currentPage: 1,
			paginationOffset: 0,
			itemsTotal: 0,
			itemsPerPage: 8,
			items: [],
			tabsElements: []
		};
	},

	mounted() {
		this.courses = this.isNewCourses ? this.newest_courses.courses : this.categories[0].courses;
		this.itemsTotal = this.courses ? this.courses.length : null;
		this.items = this.isNewCourses ? this.newest_courses.courses.slice(0, this.itemsPerPage) : this.categories[0].courses.slice(0, this.itemsPerPage);
		this.tabsElements = document.querySelectorAll('.app-catalog-tabs__btn');
	},

	computed: {
		pagesCount() {
			return Math.ceil(this.itemsTotal / this.itemsPerPage);
		},

		isNewCourses() {
			return (this.current_company_url === 'mega' || this.current_company_url === 'soft-skills' || this.current_company_url === 'scorm') ? false : true;
		}
	},

	methods: {
		showCategoriesCourses(categoryId, e) {
			const category = this.categories.filter((category) => category.id === categoryId);

			this.courses = category[0].courses;
			this.items = this.courses.slice(0, this.itemsPerPage);
			this.itemsTotal = this.courses.length;

			this.tabsElements.forEach(el => {
				el.classList.remove('is-active')
			});

			e.currentTarget.classList.add('is-active');
		},

		showNewCourses(e) {
			this.courses = this.newest_courses.courses;
			this.items = this.courses.slice(0, this.itemsPerPage);
			this.itemsTotal = this.courses.length;

			this.tabsElements.forEach(el => {
				el.classList.remove('is-active')
			});

			e.currentTarget.classList.add('is-active');
		},

		changePage(pageNum) {
			this.paginationOffset = (this.itemsPerPage * pageNum) - this.itemsPerPage;
			this.items = this.courses.slice(this.paginationOffset, this.paginationOffset + this.itemsPerPage);
		},
	}
};
</script>
